/**
 * Created by zhengyf on 2018.1.17.
 */

;(function () {

    FileUploaderFactory.$inject = ['request', '$q', '$timeout', 'progressService', 'UploaderConfig'];
    angular
        .module('app.core')
        .service('progressService', progressService)
        .factory('fileUploaderService', FileUploaderFactory)
        .directive('fileChange', fileChangeDirective)

    function progressService() {
        this.onProgress = onProgress;

        function onProgress(e, pageFileInfo, fileId) {

            // var progressPercent = Math.round(e.loaded * 100 / e.total);

            progressValue(pageFileInfo.list, pageFileInfo, fileId)

            function progressValue(files, fileObj, fileId) {
                var file,
                    totalLoadedSize = 0
                ;

                //单个图片的上传进度条 //prod.productFiles
                for (var i = 0; i < files.length; i++) {
                    file = files[i];

                    if (files[i].id === fileId) {
                        file.progress.loadedSize = e.loaded;
                    }

                    totalLoadedSize += file.progress.loadedSize;
                }
                fileObj.progress.loadedSize = totalLoadedSize;
                // console.log('uploader.js', fileObj.progress.loadedSize / fileObj.progress.totalSize, fileObj.progress.loadedSize, fileObj.progress.totalSize);
            }

        }
    }

    function FileUploaderFactory(request, $q, $timeout, progressService, UploaderConfig) {

        function Uploader() {
            this.uploadingList = [];
            this.waitList = [];
            this.MAX_UPLOAD_NUM = 1;
            this.cancelers = {};
        }

        var option = UploaderConfig.getConfig();

        Uploader.prototype.start = function (file, url, pageFileInfo, fileId) {

            var deferred = $q.defer();

            this.waitList.push({
                id: fileId,
                pageFileInfo: pageFileInfo,
                url: url,
                file: file,
                pending: deferred
            });

            if (this.getUploadNum() >= 1) {
                this.beginUpload();
            }

            return deferred.promise;
        }

        // 检查剩余上传数
        Uploader.prototype.getUploadNum = function () {
            return this.MAX_UPLOAD_NUM - this.uploadingList.length;
        }

        // 开始一个上传
        Uploader.prototype.beginUpload = function () {
            var count = this.getUploadNum();
            while (this.waitList.length && count > 0) {
                this.uploadNext();
                count = this.getUploadNum();
            }
        }

        Uploader.prototype.uploadNext = function () {
            var info = this.waitList.shift();
            if (!info) {
                console.warn('[FileUploaderFactory::Uploader] uploadNext: cannot found next file');
                return;
            }

            var uploadingList = this.uploadingList;
            uploadingList.push(info);

            // 修改状态为上传中
            modifyFileUploadStatus(info.pageFileInfo.list, info.id);

            // 开始上传
            // var uploadDeferred = this.upload(info.file, info.url, info.pageFileInfo, info.id);
            // uploadDeferred.then(uploadSuc, uploadErr);

            // todo: 把 canceler 移到这里

            var that = this;

            option.onProgress = function (f, e) {
                info.pageFileInfo.status = 'uploading';
                $timeout(function () {
                    progressService.onProgress(e, info.pageFileInfo, info.id, function () {});
                });
            };
            option.onSuccess = function (f, data) {
                uploadSuc(data);
                delete that.cancelers[info.id];
            };
            option.onError = function (f, data) {
                uploadErr(data);
                delete that.cancelers[info.id];
            };
            var uploadTmp = new uploadFactory(option);
            uploadTmp.add([info.file]);
            // 中止事件
            var deferTmp = $q.defer();
            this.cancelers[info.id] = deferTmp;
            deferTmp.promise.then(function () {
                uploadTmp.abort(info.file);
            });

            function uploadSuc(res) {
                var idx = uploadingList.indexOf(info);
                if (idx > -1) {
                    uploadingList.splice(idx, 1);
                }
                $timeout(function () {
                    that.beginUpload();
                });
                res.fileId = info.id;
                info.pending.resolve(res);
            }

            function uploadErr(err) {
                var idx = uploadingList.indexOf(info);
                if (idx > -1) {
                    uploadingList.splice(idx, 1);
                }
                $timeout(function () {
                    that.beginUpload();
                });
                if(err.type === 'UPLOAD_CHECK') {
                    err.failedFileInfo = info;
                }
                info.pending.reject(err);
            }

            function modifyFileUploadStatus(files, fileId) {
                for (var i = 0; i < files.length; i++) {

                    if (files[i].id === fileId) {
                        files[i].uploadStatus = 'uploading';
                    }
                }
            }
        }

        // 文件上传
        /**
         *
         * @param file
         * @param url
         * @param prod
         * @param otherInfo
         * @param fileId
         * @returns {*}
         */
        // Uploader.prototype.upload = function (file, url, pageFileInfo, fileId) {
        //     var canceler = $q.defer(),
        //         that = this;
        //
        //     var arg_filter = {
        //         transformRequest: angular.identity,
        //         headers: {'Content-Type': undefined},
        //         // eventHandlers: { // 上传完成触发
        //         //     progress: function(c) {
        //         //         console.log('Progress -> ' + c);
        //         //         console.log(c);
        //         //     }
        //         // },
        //         uploadEventHandlers: { // 上传的时候触发
        //             progress: function (e) {
        //                 if (e.lengthComputable) {
        //                     progressService.onProgress(e, pageFileInfo, fileId, function () {});
        //                 }
        //             }
        //         },
        //         timeout: canceler.promise,
        //     };
        //     var fd = new FormData();
        //     fd.append('file', file);
        //
        //     that.cancelers[fileId] = canceler;
        //
        //     return request.post(url, {}, fd, true, arg_filter)
        //         .then(callback, errCallback);
        //
        //     function callback(res) {
        //         delete that.cancelers[fileId];
        //         return res;
        //     }
        //
        //     function errCallback(err) {
        //         delete that.cancelers[fileId];
        //
        //         err.failedFileInfo = {
        //             id: fileId
        //         };
        //
        //         return $q.reject(err);
        //     }
        // }

        Uploader.prototype.cancel = function (fileId) {
            if (!fileId) {
                console.warn('[FileUploaderFactory::Uploader] cancel: fileId is not exist');
                return;
            }
            var that = this,
                c = that.cancelers[fileId];
            if (c) {
                c.resolve();
                delete that.cancelers[fileId];
            } else {
                // 取消在等待队列中的文件
                for (var i = 0; i < this.waitList.length; i++) {
                    if (this.waitList[i].id === fileId) {
                        this.waitList.splice(i, 1);
                        break;
                    }
                }
            }
        }

        return new Uploader();

    }

    function fileChangeDirective() {
        return {
            restrict: "A",
            scope: {
                fileChange: '&'
            },
            link: function (scope, element) {
                var slice = Array.prototype.slice;

                element.on("change.fileChangeDirective", function () {
                    scope.$apply(function () {

                        scope.fileChange({
                            $event: {
                                files: slice.call(element[0].files)
                            }
                        });
                        element[0].value = '';
                    });
                });

                element.on('destroy.fileChangeDirective', function () {

                });
            }
        }
    }


})();
